import Cropper from 'cropperjs';

angular.module('TetherApp').controller('GiftWithPurchaseAnalyzeUploadController', [function () {
    let ctrl = this;

    ctrl.questions = [];
    ctrl.questionFieldRows = {};

    function handleAnalyzeImageScroll() {
        const toolbar = document.querySelector('#toolbar');
        const analysisToolbar = document.querySelector('#analysis_toolbar');
        let toolbarsHeight = toolbar.clientHeight + analysisToolbar.clientHeight;
        let questionContainer = document.querySelector('#question_container');
        let imageContainer = document.querySelector('#image_container');
        let imageContainerHeight = imageContainer.clientHeight;
        // if viewport is smaller than image, use the viewport height
        imageContainerHeight = window.innerHeight < imageContainerHeight ? window.innerHeight : imageContainerHeight;
        let imageContainerYPosition = window.pageYOffset + imageContainerHeight - toolbarsHeight - 15;
        // 15 is the scroll_inner_container container padding

        if (window.pageYOffset > toolbarsHeight) {
            let topOffset = (imageContainerYPosition <= questionContainer.clientHeight) ?
                '10px' :
                (questionContainer.clientHeight - imageContainerYPosition - 10) + 'px';
            // 10 is just extra padding on the bottom
            imageContainer.style.position = 'fixed';
            imageContainer.style.top = topOffset;
        } else if (window.pageYOffset <= toolbarsHeight) {
            imageContainer.style.position = 'relative';
            imageContainer.style.top = 0;
        }
    }

    ctrl.init = function(questions) {
        ctrl.questions = questions;
    }

    angular.element(document).ready(function () {
        ctrl.setupQuestions();
    });

    ctrl.rotate = function (direction) {
        let rotation = direction === 'left' ? -90 : 90;
        ctrl.cropperImage.rotate(rotation);
    };

    ctrl.setupQuestions = function () {
        ctrl.questions.forEach(function (question, index) {
            if (question.type === 'details') {
                ctrl.questionFieldRows[index] = [question.configuration];
            }
        }, ctrl);
        let imageWrapper = document.querySelector('#image_wrapper'); 
        let imageContainer = document.querySelector('#uploaded_image');
        ctrl.cropperImage = new Cropper(imageContainer, {
            viewMode: 0,
            dragMode: 'move',
            autoCrop: false,
            modal: false,
            guides: false,
            highlight: false
        });

        imageContainer.addEventListener('ready', function () {
            angular.element(window).bind('scroll', handleAnalyzeImageScroll);
        });
    };

    ctrl.getQuestionFieldRows = function (index) {
        return ctrl.questionFieldRows[index];
    };

    ctrl.addFieldRow = function (index) {
        ctrl.questionFieldRows[index].push(ctrl.questions[index].configuration);
    };
}]);
